import { apiClient } from '../lib/api-client';
import type {
  PagedResultDto,
  TrainerProfileAdminDto,
  TrainerAdminQueryDto,
  SetTrainerStatusDto,
} from '../types/admin-api';

export const trainerService = {
  getAll: async (query: TrainerAdminQueryDto = {}) => {
    const response = await apiClient.get<PagedResultDto<TrainerProfileAdminDto>>(
      '/trainers',
      { params: query }
    );
    return response.data;
  },

  getById: async (id: string) => {
    const response = await apiClient.get<TrainerProfileAdminDto>(`/trainers/${id}`);
    return response.data;
  },

  setStatus: async (id: string, data: SetTrainerStatusDto) => {
    const response = await apiClient.put(`/trainers/${id}/status`, data);
    return response.data;
  },
};
